import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "flex items-center justify-between p-4 max-w-3xl bg-yellow-400 rounded"
};
var _hoisted_2 = {
  "class": "flex items-center"
};
var _hoisted_3 = {
  "class": "text-yellow-800 text-sm font-medium"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_icon = _resolveComponent("icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_icon, {
    name: "trash",
    "class": "flex-shrink-0 mr-2 w-4 h-4 fill-yellow-800"
  }), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default")])]), _createElementVNode("button", {
    "class": "text-yellow-800 hover:underline text-sm",
    tabindex: "-1",
    type: "button",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('restore');
    })
  }, "Restore")]);
}